// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  webUrl: "https://zaya-med.web.app/",
  servicesEnabled: true,
  firebaseConfig: {
    apiKey: "AIzaSyAY6IKzq6jFm6x9DqP2RFoWUB2gmpTNrw8",
    authDomain: "zaya-med.firebaseapp.com",
    databaseURL: "https://zaya-med.firebaseio.com",
    projectId: "zaya-med",
    storageBucket: "zaya-med.appspot.com",
    messagingSenderId: "385010078525",
    appId: "1:385010078525:web:e4eacee3319dfe8b1cab54",
    measurementId: "G-GFZML3KBQS"
  },
  algolia: {
    appId: "8H9WVE5XET",
    apiKey: "6ce3931597795c66d95021ae38275f62",
    searchKey: "1e20e1b0c5a0e7b2639916afcf306d94",
    practitionerIndex: "prod_practitioners",
    specialtyMindIndex: "specialties_mind",
    specialtyBodyIndex: "specialties_body",
    conditionBodyIndex: "conditions_body",
    conditionMindIndex: "conditions_mind",
    professionalBodyIndex: "professional_bodies",
    accreditedRegistersIndex: "accredited_registers"
  },
  adminUid: 'U2aZChzMEaZDXcZo6Gjz0HfAkIu2'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
